
import { PICKERS_MODALS } from './Pickers.constants'
import { getPickerVariantForSelectedPickers } from './Pickers.utils'
import PickerGroup from './components/PickerGroup'

export default {
  components: {
    PickerGroup,
  },
  props: {
    pickers: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    shouldDisplayPickers() {
      return this.pickers.length > 0
    },
    variantForSelectedPickers() {
      return getPickerVariantForSelectedPickers(this.pickers)
    },
  },
  methods: {
    hasModal(id) {
      return Boolean(PICKERS_MODALS[id])
    },
    getModal(id) {
      return PICKERS_MODALS[id]
    },
  },
}
